import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, actions } from "../../state/reducer";
import PanelSubHeading from "../panel/subHeading";
import PanelSearch from "../filters/panelSearch";
import { FilterIcon } from "../../icons/filter";
import TasksListTable from "../activity/tasksListTable";
import { taskBackend } from "../../services";
import { closeModal, openModal } from "../../state/modalSlice";
import { EventListRequestParams } from "../../forms/filters/event";
import TaskFilterModal from "../../modals/filters/task";
import CreateTaskModal from "../../modals/task/createTask";
import { toast } from "sonner";

const TasksListWidget = (props: { shorted?: boolean }) => {
  const [searchValue, setSearchValue] = useState("");
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const filters = State.taskListRequestParams;

  const search = (value: string) => {
    console.log(value);
    setSearchValue(value);
  };

  useEffect(() => {
    taskBackend
      .getTasksList(filters)
      .then((res) => {
        dispatch(actions.taskData(res.tasks));
      })
      .catch((e) => {
        console.log(e.error || e);
      });
  }, [filters]);

  const handleOpenCreationModal = () => {
    console.log("Called");
    dispatch(
      openModal({
        component: CreateTaskModal,
        context: {
          onSave: () => {
            toast("Событие создано");
            dispatch(closeModal());
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  };

  const handleOpenFilters = () => {
    dispatch(
      openModal({
        component: TaskFilterModal,
        context: {
          onApplyFilters: (filters: EventListRequestParams) => {
            setSearchValue("");
            dispatch(actions.taskRequestParams(filters));
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  };

  return (
    <div className="profileWidget">
      <div className="flex between">
        <PanelSubHeading text="Мои задачи" />
        <div className="panelBtnContainer">
          <div className="btn panelActionBtn" onClick={handleOpenCreationModal}>
            + Добавить новую задачу
          </div>
        </div>
      </div>
      <div className="flex between panelSearchContainer">
        <PanelSearch hint={"Поиск по названию"} onChange={search} />
        <div className="btn filterBtn" onClick={handleOpenFilters}>
          <FilterIcon width={20} height={20} />
        </div>
      </div>
      <TasksListTable search={searchValue} shorted={!!props.shorted} />
    </div>
  );
};

export default TasksListWidget;
